import { render, staticRenderFns } from "./preview_page_dialog.vue?vue&type=template&id=64c6f1ae&scoped=true"
import script from "./preview_page_dialog.vue?vue&type=script&lang=js"
export * from "./preview_page_dialog.vue?vue&type=script&lang=js"
import style0 from "./preview_page_dialog.vue?vue&type=style&index=0&id=64c6f1ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6f1ae",
  null
  
)

export default component.exports